import { useAppSelector } from '../reducers';
import { purchaseRequestTermsFromProductConfigurationsSelector } from '../selectors/OfferSelectors';
import { productForSkuIdSelector, skuIdIsQuantityPackSelector, skuSelector } from '../selectors/ProductsSelectors';
import { quantiyPackApiNameToQuantityNameMap } from '../v2/utils/quantiyPackApiNameToQuantityNameMap';
import { isValidQuantityPackApiName } from '../v2/utils/typeguards';
export const useProductConfigurationsToPurchaseRequest = (productConfigurations, currencyCode, queryParamTerm) => {
  const terms = useAppSelector(state => purchaseRequestTermsFromProductConfigurationsSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  const {
    products,
    quantityPacks
  } = useAppSelector(state => {
    const _products = [];
    const _quantityPacks = [];
    for (const {
      skuId,
      quantity
    } of productConfigurations) {
      const {
        apiName
      } = productForSkuIdSelector(state, {
        skuId
      });
      const isQuantityPack = skuIdIsQuantityPackSelector(state, {
        skuId
      });
      if (isQuantityPack) {
        const {
          quantityPackApiName,
          includedWithQuantityPack
        } = skuSelector(state, {
          skuId
        });
        if (!isValidQuantityPackApiName(quantityPackApiName)) {
          continue;
        }
        _quantityPacks.push({
          quantityName: quantiyPackApiNameToQuantityNameMap[quantityPackApiName],
          totalQuantity: Math.floor(quantity / includedWithQuantityPack),
          parentProductApiName: apiName
        });
      } else {
        _products.push({
          productApiName: apiName,
          totalQuantity: quantity
        });
      }
    }
    return {
      products: _products,
      quantityPacks: _quantityPacks
    };
  });
  return {
    products,
    quantityPacks,
    commitmentTerm: terms === null || terms === void 0 ? void 0 : terms.commitmentTerm,
    paymentTerm: terms === null || terms === void 0 ? void 0 : terms.paymentTerm,
    currencyCode
  };
};